"use strict"
angular.module('televisionManageModule', [
        'televisionManageRouterModule',
        'televisionChannelManageModule',
        'televisionManageNavModule',
        'televisionDistributionConfigurationModule',
        'televisionManageServiceModule'
    ])
    .controller('televisionManageCtrl', ['$scope', 'permissionService', '$q', '$stateParams', 'trsHttpService', 'televisionManageService', 'modalDialog', '$state', 'trsspliceString',
        function($scope, permissionService, $q, $stateParams, trsHttpService, televisionManageService, modalDialog, $state, trsspliceString) {
            initStatus();
            initData();
            /**
             * [getSiteRights description]获取每个站点的操作权限
             * @return null [description]
             */
            $scope.getSiteRights = function(item) {
                televisionManageService.getRight(item.SITEID, "", "tvsetsite.site").then(function(data) {
                    $scope.status.rights[item.SITEID] = data;
                });
            };

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: '',
                    PAGECOUNT: '',
                };

                $scope.status = {
                    sortMode: true,
                    dragStartIndex: '',
                    dragStartItem: '',
                    statusItems: [{
                        name: '全部状态',
                        value: '',
                    }, {
                        name: '启用',
                        value: '0'
                    }, {
                        name: '停用',
                        value: '-1'
                    }],
                    selectedStatus: {
                        name: '全部状态',
                        value: '',
                    },
                    searchWord: '',
                    rights: {}
                };

                $scope.data = {
                    items: [],
                    selectedArray: [],
                };
                permissionService.isTenantAdministrator().then(function(data) {
                    $scope.status.isTenantAdministrator = data; //是否是系统管理员
                });
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                getAllStation();
            }

            /**
             * [searchWord 检索]
             * @return {[type]} [description]
             */
            $scope.searchWord = function() {
                getAllStation();
            };

            /**
             * [getAllStation 获取所有站点数据]
             * @return {[type]} [description]
             */
            function getAllStation() {
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'queryTvSitesForCloud',
                    Status: $scope.status.selectedStatus.value,
                    SiteDesc: $scope.status.searchWord,
                };
                if ($scope.status.selectedStatus.value == '') delete params.Status;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.selectedArray = [];
                    if (angular.isArray(data)) {
                        $scope.data.items = data;
                    } else {
                        $scope.data.items = data.DATA;
                    }

                });
            }

            /**
             * [queryByDropdown 下拉列表数据切换]
             * @return {[type]} [description]
             */
            $scope.queryByDropdown = function() {
                getAllStation();
            };

            /**
             * [singleSelect 单选]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.singleSelect = function(item) {
                var n = $scope.data.selectedArray.indexOf(item);
                n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
            };

            /**
             * [selectAll 全选]
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                if ($scope.data.selectedArray.length == $scope.data.items.length) {
                    $scope.data.selectedArray = [];
                } else {
                    $scope.data.selectedArray = [];
                    for (var i in $scope.data.items) {
                        $scope.data.selectedArray.push($scope.data.items[i]);
                    }
                }
            };

            /**
             * [disabledStation 停用站点]
             * @param  {[type]} station [description]
             * @return {[type]}         [description]
             */
            function disabledStation(station) {
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'deleteSite',
                    SiteId: station.SITEID
                };
                televisionManageService.inputPassword().then(function(password) {
                    LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                        params.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                            .then(function(data) {
                                modalDialog.alertType("停用成功", "", "success", false);
                                $state.go($state.current.name, $stateParams, { reload: "manageconfig.productmanage" });
                            });
                    });
                });
            }

            /**
             * [disabledVerify 停用站点前校验]
             * @param  {[type]} station [description]
             * @return {[type]}         [description]
             */
            function disabledVerify(station) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'deleteWebsiteCondition',
                    SiteId: station.SITEID
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            /**
             * [deleteVerify 删除站点前置校验]
             * @param  {[type]} station [description]
             * @return {[type]}         [description]
             */
            function deleteVerify(station) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'checkWebsiteCondition',
                    SiteIds: trsspliceString.spliceString(station, 'SITEID', ',')
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [deleteTvStation 删除站点方法]
             * @param  {[type]} station [description]
             * @return {[type]}         [description]
             */
            function deleteTvStation(station) {
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'removeSites',
                    SiteIds: trsspliceString.spliceString(station, 'SITEID', ',')
                };
                televisionManageService.inputPassword().then(function(password) {
                    LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                        params.PassWord = "__encoded__" + Base64.encode(angular.copy(password));
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post")
                            .then(function(data) {
                                modalDialog.alertType("删除成功", "", "success", false);
                                $state.go($state.current.name, $stateParams, { reload: "manageconfig.productmanage" });
                            });
                    });
                });
            }

            /**
             * [EnabledTvStation 开启电视站点]
             * @param {[type]} item [description]
             */
            function EnabledTvStation(item) {
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'restoreSites',
                    ObjectIds: item.SITEID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('启用成功', '', 'success', false, function() {});
                    $state.go($state.current.name, $stateParams, { reload: $state.current.name });
                });
            }

            /**
             * [slideSwitch 更改开启状态]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.slideSwitch = function(item) {
                if (item.STATUS == '0') {
                    disabledVerify(item).then(function() {
                        disabledStation(item);
                    });
                } else {
                    EnabledTvStation(item);
                }
            };

            /**
             * [deleteTv 删除站点]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.deleteTv = function(item) {
                deleteVerify(item ? [item] : $scope.data.selectedArray).then(function() {
                    deleteTvStation(item ? [item] : $scope.data.selectedArray);
                });
            };

            /**
             * [dragoverCallback description;允许拖拽]
             */
            $scope.dragoverCallback = function(event, index, external, type) {
                return true;
            };

            /**
             * [dragStart description;拖拽开始]
             */
            $scope.dragStart = function(event, item, index) {
                if (!$scope.status.rights[item.SITEID].site.paixu) {
                    modalDialog.alertType("您没有相关站点的排序权限", "", "warning", "confirm", function() {});
                    return;
                }
                $scope.status.dragStartIndex = index;
                $scope.status.dragStartItem = item;
            };

            /**
             * [dragStdropCallbackart description;拖拽结束]
             */
            $scope.dropCallback = function(event, index, item, external, type, allowedType) {
                if ($scope.status.dragStartIndex == index) {
                    return;
                }
                saveSort(index);
                // return item;
            };

            /**
             * [saveSort 保存排序]
             * @param  {[type]} index [description]
             * @return {[type]}       [description]
             */
            function saveSort(index) {
                var params = {
                    serviceid: 'mlf_tvconfig',
                    methodname: 'orderTvSites',
                    startSiteId: $scope.status.dragStartItem.SITEID,
                    targetSiteId: $scope.status.dragStartIndex > index ? $scope.data.items[index].SITEID : $scope.data.items[index -1].SITEID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $state.go($state.current.name, $stateParams, { reload: "manageconfig.productmanage" });
                });
            }

            /**
             * [switchBtn 切换排序模式]
             * @return {[type]} [description]
             */
            $scope.switchBtn = function() {
                $scope.status.sortMode = !$scope.status.sortMode;
            };

            /**
             * [createNew 创建电视站点]
             * @return {[type]} [description]
             */
            $scope.createNew = function() {
                televisionManageService.createTelevision({
                    isNew: true,
                }).then(function(success) {
                    $state.go($state.current.name, $stateParams, { reload: "manageconfig.productmanage" });
                }, function(error) {});
            };

            /**
             * [modify 修改电视站点信息]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.modify = function(item) {
                televisionManageService.createTelevision({
                    isNew: false,
                    data: item
                }).then(function(success) {
                    $state.go($state.current.name, $stateParams, { reload: "manageconfig.productmanage" });
                }, function(error) {});
            };
        }
    ]);